import { useEffect, useState } from "react";

const THEME_KEY = "vw:theme";

export function useTheme() {
    const [themeName, setThemeName] = useState(() => {
        try {
            return localStorage.getItem(THEME_KEY) || "dark";
        } catch {
            return "dark";
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(THEME_KEY, themeName);
        } catch {}
    }, [themeName]);

    const toggleTheme = () => setThemeName((p) => (p === "dark" ? "light" : "dark"));

    return { themeName, toggleTheme };
}
